import React, { useState } from 'react';
import {
  makeStyles,
  Typography,
  Box,
  Button,
  IconButton,
  Icon,
  Collapse
} from '@material-ui/core';

const HistoryItem = ({ removeHistory, name, quantity, unitPrice, totalPrice, date, index }) => {
  
  const useStyles = makeStyles(theme => ({
    collapseStyle: {
      background: '#f4f4f4',
      width: '100%'
    },
    removeStyle: {
      color: '#f55'
    },
    name: {
      textTransform: 'none'
    },
    totalPrice: {
      color: theme.palette.error.main
    },
    subtitle: {
      color: theme.palette.grey[600]
    },
  }))
  
  const classes = useStyles();
  
  const [detailsIsOpen, setDetailsIsOpen] = useState(false);

  return (
    <React.Fragment>
      <Box
        width={"100%"}
        display="flex"
        alignItems="center"
        justifyContent="space-between"
      >
        <Box width={"80%"} display="flex" alignItems="center" py={1}>
          <IconButton onClick={() => removeHistory(index)}>
            <Icon className={classes.removeStyle}>close</Icon>
          </IconButton>
          <Button className={classes.name} onClick={() => setDetailsIsOpen(!detailsIsOpen)}>
            <Typography variant="subtitle2" noWrap>{name}</Typography>
          </Button>
        </Box>
        <Typography  className={classes.totalPrice} variant="h6">-${totalPrice.toFixed(2)}</Typography>
      </Box>
      <Box
        className={classes.collapseStyle}
        component={Collapse}
        in={detailsIsOpen} 
        timeout="auto"
        unmountOnExit
        alignSelf="flex-start"
      >
        <Box m={1}>
          <Typography variant="subtitle2" className={classes.subtitle}> Product Name:</Typography>
          <Typography variant="h6">{name}</Typography>
        </Box>
        <Box m={1}>
          <Typography variant="subtitle2" className={classes.subtitle}>Purchase Date:</Typography>
          <Typography>{date}</Typography>
        </Box>
        <Box m={1}>
          <Typography variant="subtitle2" className={classes.subtitle}>Quantity:</Typography>
          <Typography>{quantity}</Typography>
        </Box>
        <Box m={1}>
          <Typography variant="subtitle2" className={classes.subtitle}>Price per Unit:</Typography>
          <Typography>${unitPrice.toFixed(2)}</Typography>
        </Box>
      </Box>
    </React.Fragment>
  )
}

export default HistoryItem;